import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { IAction } from "reduxsauce";

import { Creators as AllCreators } from "../../actions";
import CoursesPage from "../../components/pages/Courses";
import Forbidden from "../../components/pages/Forbidden";
import { SideMenu } from "../../components/utils/SideMenu/SideMenu.container";
import { SideMenuArrowContext, SideMenuCloseArrow } from "../../components/utils/SideMenu/SideMenuCloseArrow";
import Spinner from "../../components/utils/Spinner";
import SubTopbar from "../../components/utils/SubTopbar";
import TopBar from "../../components/utils/TopBar";
import * as selectors from "../../selectors/selectors";
import { IAuthenticationState, IState } from "../reducer";
import { ICourse, IScormPackage, RequestState } from "../types/common";

const Creators = (AllCreators as any).App.Courses;

export interface ICoursesStateProps {
  courses: ICourse[];
  deleteCourseRequestError: string | null;
  deleteCourseRequestState: RequestState;
  fetchAllCoursesRequestError: string | null;
  fetchAllCoursesRequestState: RequestState;
  fetchAllScormPackagesRequestError: string | null;
  fetchAllScormPackagesRequestState: RequestState;
  authenticationState: IAuthenticationState;
  isAdmin: boolean;
  organizationName: string;
  scormPackages: IScormPackage[];
  userName: string;
}

export interface ICoursesDispatchProps {
  mount: () => void;
  unmount: () => void;
  createCourse: () => void;
  deleteCourse: (courseId: string) => () => void;
}

export interface ICoursesState {
  menuExpanded: boolean;
}

export type ICoursesProps = ICoursesStateProps & ICoursesDispatchProps;

export class Courses extends React.Component<ICoursesProps, ICoursesState> {
  public static contextType = SideMenuArrowContext;
  constructor(props: ICoursesProps, context: {}) {
    super(props, context);
    this.state = {
      menuExpanded: false,
    };
  }

  public componentDidMount() {
    this.props.mount();
  }

  public componentWillUnmount() {
    this.props.unmount();
  }

  public render() {
    const {
      authenticationState: { isKnown, isAuthenticated },
      isAdmin,
      organizationName,
      userName,
      fetchAllCoursesRequestState,
      fetchAllScormPackagesRequestState,
      courses,
      createCourse,
      deleteCourse,
      deleteCourseRequestState,
      scormPackages,
    } = this.props;
    const { isOpen } = this.context;
    const loading =
      !isKnown ||
      fetchAllCoursesRequestState !== RequestState.SUCCEEDED ||
      fetchAllScormPackagesRequestState !== RequestState.SUCCEEDED ||
      deleteCourseRequestState === RequestState.PENDING;
    if (loading) {
      return <Spinner />;
    }
    if (!isAuthenticated || !isAdmin) {
      return <Forbidden />;
    }
    return (
      <>
        <TopBar onToggleMenuClick={this.onToggleMenuClick} showToggleMenu={true} userName={this.props.userName} />
        <SideMenu
          expanded={this.state.menuExpanded}
          onClose={this.onToggleMenuClick}
          organizationName={organizationName}
          userName={userName}
          isOpen={isOpen}
        />
        <SideMenuCloseArrow />
        <SubTopbar withSidebar={true} isOpen={isOpen}>
          <CoursesPage
            courses={courses}
            scormPackages={scormPackages}
            createCourse={createCourse}
            deleteCourse={deleteCourse}
          />
        </SubTopbar>
      </>
    );
  }

  public onToggleMenuClick = () => {
    this.setState({ menuExpanded: !this.state.menuExpanded });
  };
}

const mapStateToProps = (state: IState): ICoursesStateProps => ({
  authenticationState: state.App._.authenticationState,
  courses: selectors.courses(state),
  deleteCourseRequestError: state.App.Courses._.deleteCourseRequestError,
  deleteCourseRequestState: state.App.Courses._.deleteCourseRequestState,
  fetchAllCoursesRequestError: state.App.Courses._.fetchAllCoursesRequestError,
  fetchAllCoursesRequestState: state.App.Courses._.fetchAllCoursesRequestState,
  fetchAllScormPackagesRequestError: state.App.Courses._.fetchAllScormPackagesRequestError,
  fetchAllScormPackagesRequestState: state.App.Courses._.fetchAllScormPackagesRequestState,
  isAdmin: selectors.isAdminUser(state),
  organizationName: selectors.organizationName(state),
  scormPackages: state.App.Courses._.scormPackages || [],
  userName: selectors.accountName(state),
});

export default connect<ICoursesStateProps, ICoursesDispatchProps, {}, IState>(
  mapStateToProps,
  (dispatch: Dispatch<IAction>) => ({
    createCourse: () => dispatch(Creators.createCourse()),
    deleteCourse: (courseId: string) => () => dispatch(Creators.deleteCourse(courseId)),
    mount: () => {
      dispatch(Creators.mount());
      dispatch(Creators.fetchAllCourses());
      dispatch(Creators.fetchAllScormPackages());
    },
    unmount: () => dispatch(Creators.unmount()),
  })
)(Courses);
